{
  "role": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-fs-mfrs_2022-12-31/ssmt-fs-mfrs_2022-12-31_role-740000",
  "sheetId": "NotesIssuedCapital",
  "label": "[740000] Notes - Issued Capital",
  "description": "Disclosure of classes of share capital (MFRS)",
  "controls": [
    {
      "qname": "ssmt-mfrs:DisclosureOnIssuedCapitalAbstract",
      "label": "Disclosure on issued capital",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfClassesOfShareCapitalExplanatory",
      "label": "Disclosure of classes of share capital",
      "type": "TextBlock",
      "required": true,
      "ui": {
        "control": "richtext",
        "rows": 8
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfClassesOfShareCapitalHeader",
      "label": "Disclosure of classes of share capital",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ssmt-mfrs:IssuedCapitalHeader",
      "label": "Issued capital",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 3
      }
    },
    {
      "qname": "ssmt-mfrs:SharesIssuedAndFullyPaidHeader",
      "label": "Shares issued and fully paid",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 4
      }
    },
    {
      "qname": "ssmt-mfrs:NumberOfSharesIssuedAndFullyPaidHeader",
      "label": "Number of shares issued and fully paid",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 5
      }
    },
    {
      "qname": "ifrs-full:NumberOfSharesIssuedAndFullyPaid",
      "label": "Number of shares issued and fully paid",
      "type": "IntegerItemType",
      "required": true,
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ui": {
        "control": "number",
        "tableColumn": true,
        "useGrouping": true,
        "positiveWholeNumber": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherChangesInNumberOfSharesIssuedAndFullyPaid",
      "label": "Other changes in number of shares issued and fully paid",
      "type": "IntegerItemType",
      "required": true,
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ui": {
        "control": "number",
        "tableColumn": true,
        "useGrouping": true,
        "positiveWholeNumber": true
      }
    },
    {
      "qname": "ssmt-mfrs:AmountOfSharesIssuedAndFullyPaidHeader",
      "label": "Amount of shares issued and fully paid",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 5
      }
    },
    {
      "qname": "ssmt-mfrs:AmountOfSharesIssuedAndFullyPaidOutstanding:Beginning",
      "label": "Balance at the beginning of period",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:AmountOfSharesIssuedAndFullyPaidDuringPeriod",
      "label": "Shares issued during financial year",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:AmountOfSharesIssuedForCashUnderESOS",
      "label": "Issued for cash under ESOS",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:AmountOfSharesIssuedForCashUnderPrivatePlacement",
      "label": "Issued for cash under private placement",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:AmountOfSharesArisingFromConversionOfICULSBySurrenderOption",
      "label": "Arising from conversion of ICULS by surrender option",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:AmountOfSharesArisingFromConversionOfICULSByMandatoryConversion",
      "label": "Arising from conversion of ICULS by mandatory conversion",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:AmountOfOtherChangesInSharesIssuedAndFullyPaid",
      "label": "Other changes in shares issued and fully paid",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:AmountOfSharesIssuedAndFullyPaidOutstanding:End",
      "label": "Balance at the end of period",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:SharesIssuedButNotFullyPaidHeader",
      "label": "Shares issued but not fully paid",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 4
      }
    },
    {
      "qname": "ssmt-mfrs:NumberOfSharesIssuedButNotFullyPaidHeader",
      "label": "Number of shares issued but not fully paid",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 5
      }
    },
    {
      "qname": "ifrs-full:NumberOfSharesIssuedButNotFullyPaid",
      "label": "Number of shares issued but not fully paid",
      "type": "IntegerItemType",
      "required": true,
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ui": {
        "control": "number",
        "tableColumn": true,
        "useGrouping": true,
        "positiveWholeNumber": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherChangesInNumberOfSharesIssuedAndNotFullyPaid",
      "label": "Other changes in number of shares issued but not fully paid",
      "type": "IntegerItemType",
      "required": true,
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ui": {
        "control": "number",
        "tableColumn": true,
        "useGrouping": true,
        "positiveWholeNumber": true
      }
    },
    {
      "qname": "ssmt-mfrs:AmountOfSharesIssuedButNotFullyPaidHeader",
      "label": "Amount of shares issued but not fully paid",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 5
      }
    },
    {
      "qname": "ssmt-mfrs:AmountOfOtherChangesInSharesIssuedButNotFullyPaid",
      "label": "Other changes in shares issued but not fully paid",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "control": "number",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:SharesOutstandingHeader",
      "label": "Shares outstanding",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 4
      }
    },
    {
      "qname": "ssmt-mfrs:NumberOfSharesOutstandingHeader",
      "label": "Number of shares outstanding",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 5
      }
    },
    {
      "qname": "ifrs-full:NumberOfSharesOutstanding:Beginning",
      "label": "Number of shares outstanding at beginning of period",
      "type": "IntegerItemType",
      "required": true,
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ui": {
        "control": "number",
        "tableColumn": true,
        "useGrouping": true,
        "positiveWholeNumber": true
      }
    },
    {
      "qname": "ssmt-mfrs:NumberOfOutstandingSharesIssuedDuringPeriod",
      "label": "Number of outstanding shares issued during financial year",
      "type": "IntegerItemType",
      "required": true,
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ui": {
        "control": "number",
        "tableColumn": true,
        "useGrouping": true,
        "positiveWholeNumber": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherChangesInNumberOfSharesOutstandingDuringPeriod",
      "label": "Other changes in number of shares outstanding",
      "type": "IntegerItemType",
      "required": true,
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ui": {
        "control": "number",
        "tableColumn": true,
        "useGrouping": true,
        "positiveWholeNumber": true
      }
    },
    {
      "qname": "ifrs-full:NumberOfSharesOutstanding:End",
      "label": "Number of shares outstanding at end of period",
      "type": "IntegerItemType",
      "required": true,
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ui": {
        "control": "number",
        "tableColumn": true,
        "useGrouping": true,
        "positiveWholeNumber": true
      }
    },
    {
      "qname": "ssmt-mfrs:AmountOfSharesOutstandingHeader",
      "label": "Amount of shares outstanding",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 5
      }
    },
    {
      "qname": "ssmt-mfrs:AmountOfSharesOutstanding:Beginning",
      "label": "Amount of shares outstanding at beginning of period",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "control": "number",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:AmountOfOutstandingSharesIssuedDuringPeriod",
      "label": "Amount of outstanding shares issued during financial year",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "control": "number",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherChangesInAmountOfSharesOutstanding",
      "label": "Other changes in amount of shares outstanding",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "control": "number",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:AmountOfSharesOutstanding:End",
      "label": "Amount of shares outstanding at end of period",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "control": "number",
        "tableColumn": true
      }
    }
  ]
}
